import { tokenStorage } from "@/app/lib/api/tokenStorage";
import { sessionStorage } from "@/app/lib/storage/sessionStorage";

const ENDPOINT = `${process.env.NEXT_PUBLIC_API_BASE_URL}/general/frontend-error`;
const STACK_LIMIT = 4000;
let lastReported = "";

const readHtmlDpl = (): string | undefined => {
  try {
    return document.documentElement.dataset.dplId;
  } catch {
    return undefined;
  }
};

export const reportClientError = (
  error: Error & { digest?: string },
  boundary: string,
): void => {
  if (typeof window === "undefined") return;

  try {
    const key = `${boundary}|${error.digest ?? ""}|${error.message}`;
    if (key === lastReported) return;
    lastReported = key;

    const token = tokenStorage.getAccessToken();
    const sessionId = sessionStorage.getSessionId();
    const buildId = process.env.NEXT_PUBLIC_BUILD_ID;
    const htmlDpl = readHtmlDpl();

    void fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(sessionId ? { "X-Session-Id": sessionId } : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        message: error.message,
        digest: error.digest,
        path: window.location.pathname + window.location.search,
        boundary,
        stack: error.stack?.slice(0, STACK_LIMIT),
        build_id: buildId,
        html_dpl: htmlDpl,
        skew: Boolean(buildId && htmlDpl && buildId !== htmlDpl),
        user_agent: navigator.userAgent,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Error reporting must never affect the fallback UI.
  }
};

export default reportClientError;